<template>
  <div>
    <!-- Popup -->
    <vs-popup :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false"
      :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <!-- Category -->
            <div class="vx-row mb-2">
              <label class="vs-input--label">Category *</label>
              <select-2 class="w-full" :name="'category'" placeholder="Select Category" v-validate="'required'"
                :options="CATEGORIES" autocomplete :ssr="true" :multiple="false" :value="form.category"
                data-vv-as="Category" @input="(item) => (form.category = item && item.value)" />
              <span class="text-danger text-sm" v-show="errors.has(`category`)">{{ errors.first(`category`) }}</span>
            </div>

            <!-- Title -->
            <div class="vx-row mb-2">
              <vs-input class="w-full" v-validate="'required|exclude_special_char|min:4'" v-model="form.title"
                label="Title *" name="title" data-vv-as="Title" id="Title" placeholder="The Sounds of Punjab" />
              <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
            </div>
            <div class="vx-row mb-2">
              <label class="vs-input--label">Creator *</label>
              <select-2 class="w-full category-input" name="Creator" placeholder="Select Creator" :value="form.creators"
                @input="(item) => (form.creators = item && item.value)" autocomplete :ssr="true" :multiple="false"
                v-validate="'required'" action="creator/get" :options="creators"
                :params="{ creatorIds: JSON.stringify(form.creators) }" data-vv-as="Creator" />
              <span class="text-danger text-sm" v-show="errors.has('Creator')">{{ errors.first('Creator') }}</span>
            </div>

            <!-- Emotions -->
            <div class="vx-row mb-2">
              <label class="vs-input--label">Emotions</label>
              <select-2 class="w-full" :name="'emotions'" placeholder="Select Emotions" :options="emotionsList"
                :autocomplete="true" :ssr="false" :multiple="true" :value="form.emotions" data-vv-as="Emotions"
                @input="(item) => (form.emotions = item && item.value)" />
            </div>
          </div>
          <div class="vx-col w-full cursor-pointer">
            <label class="vs-input--label block">Video *</label>
            <input type="file" class="border p-2 rounded w-full" name="Video" ref="files" accept=".mp4, .mkv, .mov"
              @change="handleVideoUpload" style="border: 1px solid rgba(0, 0, 0, 0.2)" v-validate="videovalidationRule"
              data-vv-as="Video" />
            <span class="text-danger text-sm" v-show="errors.has('Video')">{{ errors.first('Video') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="preview_video">
                <video height="150" width="500" :src="preview_video" controls></video>
              </div>
            </div>
          </div>
          <div class="vx-col w-full cursor-pointer">
            <label class="vs-input--label block">Thumbnail *</label>
            <input :key="fileKey" type="file" class="border p-2 rounded w-full" ref="files" accept=".jpg, .png , .jpeg"
              @change="handleFileUpload" style="border: 1px solid rgba(0, 0, 0, 0.2)" data-vv-as="Thumbnail" />
            <input type="hidden" name="thumbnail" v-model="form.thumbnail" v-validate="imagevalidationRule"
              data-vv-as="Thumbnail" />
            <span class="text-danger text-sm" v-show="errors.has('thumbnail')">{{ errors.first('thumbnail') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="preview_thumbnail">
                <div class="h-64 w-64 mt-5 overflow-hidden">
                  <img height="200px" width="250px" :src="preview_thumbnail" alt="Thumbnail Preview"
                    class="object-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="create-video" @click="save_changes">{{ action_name
                }}</vs-button>
              <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup title="Thumbnail Cropper" name="Thumbnail" :active.sync="IsOpenThumbnailCrop" class="thumbnail-cropper"
      style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper ref="cropper" name="thumbnail" class="cropper-image" :src="this.crop_thumbnail.src"
                  :stencil-props="{
                    aspectRatio: 16 / 9
                  }" />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropThumbnail()" class="text-primary border border-solid border-primary">Crop
                  Thumbnail</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: `VideoAction`,

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** Props */
  props: {
    showModal: Boolean,
    data: Object,
    module_name: String,
    action_name: String
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      form: {
        title: '',
        thumbnail: null,
        video: null,
        creators: '',
        category: null,
        emotions: []
      },
      creators: [],
      emotionsList: [
        { value: 'happy', label: 'Happy 😊' },
        { value: 'sad', label: 'Sad 😢' },
        { value: 'fear', label: 'Fear 😱' },
        { value: 'anger', label: 'Anger 😠' },
        { value: 'surprised', label: 'Surprised 😐' },
        { value: 'guilt', label: 'Guilt 😥' },
        { value: 'confused', label: 'Confused 🤔' },
        { value: 'in_love', label: 'In Love 🥰' }
      ],
      preview_thumbnail: null,
      preview_video: null,
      CATEGORIES: [],
      crop_thumbnail: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenThumbnailCrop: false
    }
  },

  /** created */
  async created() {
    if (this.data) {
      this.form.category = this.data.category ? this.data.category : ''
      this.form.title = this.data.title ? this.data.title : ''
      this.form.creators = this.data.creators ? this.data.creators[0]._id : ''
      this.form.emotions = this.data.emotions ? this.data.emotions : []
      this.preview_thumbnail = this.data.thumbnail ? this.data.thumbnail : null
      this.preview_video = this.data.video ? this.data.video : null
    }

    const { video } = await this.getPreDefinedValues()
    this.CATEGORIES = video.category.map((value) => {
      return {
        value,
        label: value
      }
    })

    const { data } = await this.getDropdownCreators()
    this.creators = data.results.map((value) => {
      return {
        value: value._id,
        label: value.name
      }
    })
  },
  /** computed */
  computed: {
    ...mapState('video', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    },
    thumbnailvalidationRule() {
      return !this.data ? 'required' : ''
    },
    videovalidationRule() {
      return !this.data ? 'required' : ''
    }
  },

  /** methods */
  methods: {
    ...mapActions('video', {
      create: 'create',
      update: 'update'
    }),
    ...mapActions('common', {
      getPreDefinedValues: 'getPreDefinedValues',
      getDropdownCreators: 'getDropdownCreators'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.data && !this.form.thumbnail) {
        this.$vs.notify({
          title: 'Error',
          text: 'Thumbnail Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const data = new FormData()
        if (this.form.thumbnail) {
          data.append('thumbnail', this.form.thumbnail)
        }
        if (this.form.video) {
          data.append('video', this.form.video)
        }
        data.append('creators[]', this.form.creators)

        data.append('title', this.form.title)
        data.append('category', this.form.category)
        if (this.form.emotions && this.form.emotions.length) {
          this.form.emotions.forEach((emotion) => {
            data.append('emotions[]', emotion)
          })
        }
        let result
        if (!this.data) {
          result = await this.create(data)
        } else {
          result = await this.update({
            id: this.data._id,
            data
          })
        }
        const message = result.message
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.isActive = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** file upload  */
    handleFileUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const blob = URL.createObjectURL(file)

      this.crop_thumbnail = {
        src: blob,
        type: file.type
      }

      // e.target.value = ''
      this.IsOpenThumbnailCrop = true

      // Increment fileKey to force re-render
      this.fileKey++
    },

    cropThumbnail() {
      const result = this.$refs.cropper.getResult()
      if (result.canvas === undefined) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Thumbnail',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const resultTest = result.canvas.toDataURL(this.crop_thumbnail.type)
      const base64Image = resultTest.replace(`data:${this.crop_thumbnail.type};base64,`, '')
      this.b64toBlob(base64Image, this.crop_thumbnail.type)

      this.IsOpenThumbnailCrop = false
    },

    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, 'thumbnail.jpg', {
        type: contentType
      })
      this.form.thumbnail = blob
      this.preview_thumbnail = URL.createObjectURL(blob)
      return blob
    },

    handleVideoUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.form.video && this.form.video.src) {
        URL.revokeObjectURL(this.form.video.src)
      }
      // 2. Create the video link to the file to optimize performance:
      this.preview_video = URL.createObjectURL(file)
      this.form.video = file
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-video',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-video > .con-vs-loading')
      }
    }
  }
}
</script>
<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
</style>
